export default {
  metaDescription: {
    id: 'product_meta_description',
    defaultMessage:
      '{category} {brand} {title} ✌ Up to 70% off compared to new ✅ Free delivery ✅ Cheap {model} ✅ {warrantyDuration} year warranty ✅ {coolingOffDays}-day money-back guarantee',
  },
  newTreePlanted: {
    id: 'new_tree_planted',
    defaultMessage: '1 tree planted',
  },
  electronicWasteNew: {
    id: 'electronic_waste_new',
    defaultMessage: '- {waste} of electronic waste',
  },
  stateOfProduct: {
    id: 'state_of_product',
    defaultMessage: 'Choose the esthetic condition',
  },
  moreInformations: {
    id: 'more_informations',
    defaultMessage: 'What is this?',
  },
  alreadySold: {
    id: 'already_sold',
    defaultMessage: 'Sold',
  },
  merchantCommentary: {
    id: 'merchant_commentary',
    defaultMessage: 'Refurbisher comments:',
  },
  verificationBy: {
    id: 'verification_by',
    defaultMessage: 'These functions have been tested by',
  },
  waterproof: {
    id: 'waterproof',
    defaultMessage:
      'Please be advised. Refurbished phones are not guaranteed to maintain their waterproof seal.',
  },
  foreverPlus: {
    id: 'forever_plus',
    defaultMessage: 'Learn more',
  },
  fightAgainstObsolescence: {
    id: 'fight_against_obsolescence',
    defaultMessage: 'Fight against planned obsolescence:',
  },
  soundAndFurious: {
    id: 'sound_and_furious',
    defaultMessage: '"The sound and the fury"',
  },
  popularSearch: {
    id: 'popular_search',
    defaultMessage: 'our most popular searches',
  },
  helloCousin: {
    id: 'hello_cousin',
    defaultMessage: '"Meet the clique"',
  },
  similarProduct: {
    id: 'similar_product',
    defaultMessage: 'similar products',
  },
  helloCousinTop: {
    id: 'hello_cousin_top',
    defaultMessage: '"Meet the clique"',
  },
  similarProductTop: {
    id: 'similar_product_top',
    defaultMessage: 'similar products',
  },
  productVatIncludedInfo: {
    id: 'product_vat_included_info',
    defaultMessage: '',
  },
  productVatFaqLink: {
    id: 'product_vat_faq_link',
    defaultMessage: '',
  },
  productVatFaq: {
    id: 'product_vat_faq',
    defaultMessage: 'Learn more',
  },
  productPageNotFoundError: {
    id: 'product_page_not_found_error',
    defaultMessage: 'Product not found',
  },
  reviews: {
    id: 'reviews',
    defaultMessage: 'reviews',
  },
  onTheProductNew: {
    id: 'on_the_product_new',
    defaultMessage: 'on the product {title}',
  },
  reviewLink: {
    id: 'landing_merchant_best_sales_reviews_link',
    defaultMessage: 'See all the reviews',
  },
  refurbishedByBlock: {
    id: 'refurbished_by_block',
    defaultMessage: 'This product was refurbished by:',
  },
  vanishingDeal: {
    id: 'product_page_vanishing_deal',
    defaultMessage: 'Vanishing deal',
  },
  vanishingDealStock: {
    id: 'vanishing_product_stock',
    defaultMessage: 'Only {stock} left!',
  },
  vanishingDealUnitHours: {
    id: 'product_page_vanishing_deal_unit_hours',
    defaultMessage: 'h',
  },
  vanishingDealUnitMinutes: {
    id: 'product_page_vanishing_deal_unit_minutes',
    defaultMessage: 'm',
  },
  vanishingDealUnitSeconds: {
    id: 'product_page_vanishing_deal_unit_seconds',
    defaultMessage: 's',
  },
  verifiedRefurbishedLabel: {
    id: 'product_page_verified_refurbished_label',
    defaultMessage: 'Verified refurbished',
  },
  strikedPriceExplanation: {
    id: 'stroked_price_explanation',
    defaultMessage:
      "Crossed out prices may be the manufacturer's suggested retail price, or may be calculated from the average price of the product from different retail distributors.",
  },
  productVatIncluded: {
    id: 'product_vat_included',
    defaultMessage: 'VAT inclusive',
  },
  warrantyRefund: {
    id: 'product_page_warranty_refund',
    defaultMessage: '{days}-day hassle-free returns',
  },
}
